import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {
  DialogActions,
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Divider
} from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { shapes } from '@greenville/framework';
import Permissions from '../models/Permissions';
import rolesDialogConfig from '../../../common/config/users/RolesDialogConfig';
import { styles } from './UserStyle';
import * as constants from '../../../common/constants';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
@inject('userPermissions', 'permissions')
@observer
class RoleDialog extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    closeRoleDialog: PropTypes.func.isRequired,
    saveRole: PropTypes.func.isRequired,
    permissions: shapes.modelOf(Permissions).isRequired,
    editRole: PropTypes.string.isRequired,
    showEditData: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      openDialog: true,
      rolesData: {
        roleName: null,
        roleDescription: null,
        permissions: [],
        roleTypeId: null
      },
      error: false
    };
  }

  componentDidMount() {
    const { editRole, showEditData } = this.props;

    if (editRole && showEditData) {
      this.setState({
        rolesData: {
          roleName: showEditData.role || '',
          roleDescription: showEditData.description || '',
          permissions: [...showEditData.permissions],
          roleTypeId: showEditData.roleId || ''
        }
      });
    }
  }

  handleSave = () => {
    const { saveRole, editRole } = this.props;
    const { rolesData } = this.state;
    if (rolesData) {
      Object.keys(rolesData).map((key) => {
        if (_.isString(rolesData[key])) {
          rolesData[key] = rolesData[key].trim();
        }
        return rolesData;
      });
    }
    const isValidated = this.validateSave(rolesDialogConfig.requiredFields);
    if (isValidated) {
      const payload = !editRole ? _.omit(rolesData, 'roleTypeId') : rolesData;

      saveRole(payload);
      this.handleClose();
    } else {
      this.setState({ error: true });
    }
  };

  validateData = (value) => {
    const { rolesData } = this.state;
    if (_.isEmpty(rolesData[value]) || _.isNil(rolesData[value])) {
      return true;
    }
    return false;
  };

  validateSave = (requiredArr) => {
    let bool = true;
    let required = false;
    requiredArr.forEach((value) => {
      required = this.validateData(value);
      if (required) {
        bool = false;
      }
    });
    return bool;
  };

  handleClose = () => {
    const { closeRoleDialog } = this.props;
    closeRoleDialog();
  };

  handleChange = (e) => {
    const { rolesData, error } = this.state;
    if (rolesData[e.target.name] === '0') {
      this.setState({
        error: !error
      });
    } else {
      this.setState({
        error: false
      });
    }
    let updatedObject = {};
    const intProperties = ['permissions'];
    if (intProperties.includes(e.target.name)) {
      const intValue = rolesData.permissions;
      if (intValue.indexOf(e.target.value) > -1) {
        const index = intValue.indexOf(e.target.value);
        intValue.splice(index, 1);
      } else {
        intValue.push(e.target.value);
      }
      updatedObject = {
        [e.target.name]: intValue
      };
    } else {
      updatedObject = {
        [e.target.name]: e.target.value
      };
    }
    this.setState({
      rolesData: { ...rolesData, ...updatedObject }
    });
  };

  render() {
    const { classes, permissions, editRole } = this.props;
    const { openDialog, rolesData } = this.state;
    const half = Math.ceil(permissions.data.length / 2);
    const firstHalf = permissions.data.slice(0, half);
    const secondHalf = permissions.data.slice(half);
    return (
      <>
        <Dialog
          fullWidth="true"
          maxWidth="md"
          open={openDialog}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar} color="primary">
            <Toolbar>
              <Typography variant="h3" className={classes.title}>
                {editRole ? constants.UPDATE_ROLE : constants.ADD_NEW_ROLE}
              </Typography>
              <IconButton edge="end" color="inherit" onClick={this.handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Divider className={classes.divider} />
          <Grid container className={classes.grid}>
            <Grid item xs={10}>
              <Grid container direction="row" alignItems="center" spacing={2}>
                <Grid item xs={5}>
                  <Typography variant="h5" color="textPrimary">
                    {constants.ROLE}
                    <span className={classes.errorStyle}> * </span>
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    error={this.validateData('roleName')}
                    className={classes.textFields}
                    value={rolesData.roleName}
                    margin="dense"
                    name="roleName"
                    id="roleName"
                    variant="outlined"
                    onChange={this.handleChange}
                    InputProps={{ classes: { input: classes.textfieldInput } }}
                  />
                </Grid>
              </Grid>
              <Grid container direction="row" alignItems="center" spacing={2}>
                <Grid item xs={5}>
                  <Typography variant="h5" color="textPrimary">
                    Description
                    <span className={classes.errorStyle}> * </span>
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    className={classes.textFields}
                    value={rolesData.roleDescription}
                    error={this.validateData('roleDescription')}
                    name="roleDescription"
                    id="roleDescription"
                    onChange={this.handleChange}
                    margin="dense"
                    variant="outlined"
                    InputProps={{ classes: { input: classes.textfieldInput } }}
                  />
                </Grid>
              </Grid>
              <Grid container direction="row" alignItems="center" spacing={2}>
                <Grid item xs={5}>
                  <Typography variant="h5" color="textPrimary">
                    Permissions
                    <span className={classes.errorStyle}> * </span>
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Grid container direction="row" alignItems="center" spacing={2}>
                    <Grid item xs={6}>
                      <FormGroup value={rolesData.permissions} name="permissions" onChange={this.handleChange}>
                        {firstHalf.map((permissionValue) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="permissions"
                                value={permissionValue.permission}
                                checked={rolesData.permissions.includes(permissionValue.permission)}
                              />
                            }
                            className={classes.checkboxfieldInput}
                            label={permissionValue.permission}
                          />
                        ))}
                      </FormGroup>
                    </Grid>
                    <Grid item xs={6}>
                      <FormGroup value={rolesData.permissions} name="permissions" onChange={this.handleChange}>
                        {secondHalf.map((permissionValue) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="permissions"
                                value={permissionValue.permission}
                                checked={rolesData.permissions.includes(permissionValue.permission)}
                              />
                            }
                            className={classes.checkboxfieldInput}
                            label={permissionValue.permission}
                          />
                        ))}
                      </FormGroup>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <DialogActions>
            <span>
              <Button id="saveBtn" variant="outlined" color="primary" size="small" onClick={this.handleSave}>
                Save
              </Button>
            </span>
            <span>
              <Button id="cancelBtn" variant="outlined" color="primary" size="small" onClick={this.handleClose}>
                Cancel
              </Button>
            </span>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withStyles(styles)(inject('language')(observer(RoleDialog)));
